var _style, _g, _ellipse, _path, _path2, _circle, _path3, _path4, _ellipse2, _path5, _ellipse3, _ellipse4, _path6, _ellipse5, _ellipse6, _path7, _path8, _ellipse7, _path9, _path10, _path11, _ellipse8, _path12, _g2, _rect, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoperFullLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 221.3",
    style: {
      enableBackground: "new 0 0 792 221.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.5,22.9h53.6c11.9,0,20.9,3.1,27,9.4c6.1,6.3,9.1,15.2,9.1,26.8c0,11.1-3.3,19.7-9.9,25.9 c-6.6,6.2-14.9,9.3-25.1,9.3h-6.4l42.9,55.5h-25.2l-45.8-62.1v62.1h-20.2V22.9z M256.7,43.1v37.3h23.6c10,0,16.7-1.6,20.3-4.8 c3.6-3.2,5.3-8,5.3-14.4c0-12.1-7.1-18.1-21.2-18.1H256.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.2,82.2c0-18.4,4.5-33.3,13.5-44.8c9.1-11.5,22.4-17.2,40-17.2c16.8,0,29.9,5.6,39.3,16.9 c9.5,11.2,14.2,26.5,14.2,45.7c0,21.8-4.6,38.9-13.9,51.3c-9.2,12.3-22.4,18.5-39.7,18.5c-17.6,0-30.9-6.3-40-18.8 C339.7,121.2,335.2,104.1,335.2,82.2z M355.4,85.1c0,33,11.1,49.5,33.3,49.5c22.2,0,33.3-16.4,33.3-49.2c0-29.3-11.1-44-33.3-44 C366.5,41.4,355.4,55.9,355.4,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.8,22.9h51.6c27.2,0,40.8,13.6,40.8,40.7c0,29.3-14.9,43.9-44.8,43.9H477v42.3h-20.2V22.9z M477,43.1v46.4 h28.6c15.5,0,23.3-8.3,23.3-24.9c0-14.4-7.9-21.5-23.7-21.5H477z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M562.2,149.9V22.9h76.3v20.2h-56.1v34.5h56.1v18h-56.1v36.3h56.1v18H562.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.9,22.9h53.6c11.9,0,20.9,3.1,27,9.4c6.1,6.3,9.1,15.2,9.1,26.8c0,11.1-3.3,19.7-9.9,25.9 c-6.6,6.2-14.9,9.3-25.1,9.3h-6.4l42.9,55.5H724l-45.8-62.1v62.1h-20.2V22.9z M678.1,43.1v37.3h23.6c10,0,16.7-1.6,20.3-4.8 c3.6-3.2,5.3-8,5.3-14.4c0-12.1-7.1-18.1-21.2-18.1H678.1z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2772 -0.9608 0.9608 0.2772 18.073 148.9941)",
    className: "st0",
    cx: 108.1,
    cy: 62.5,
    rx: 13.9,
    ry: 13.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.8,152.9c0,7.7-6.2,13.9-13.9,13.9c-7.6,0-13.9-6.2-13.9-13.9c0-7.6,6.2-13.8,13.9-13.8 C135.6,139.1,141.8,145.3,141.8,152.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.8,161.2c0,7.7-6.2,13.8-13.9,13.8c-7.7,0-13.9-6.2-13.9-13.8c0-7.7,6.2-13.9,13.9-13.9 C107.6,147.3,113.8,153.5,113.8,161.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100,
    cy: 189.9,
    r: 13.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.4,23.9c-3.1,1.9-7.1,1-9-2.1c-1.9-3.1-1-7.1,2.1-9c3.1-1.9,7.1-1,9,2.1C128.4,17.9,127.5,22,124.4,23.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.1,44.8c-4,2.5-9.3,1.3-11.8-2.8c-2.5-4-1.3-9.3,2.8-11.8c4-2.5,9.3-1.3,11.8,2.8 C125.3,36.9,124.1,42.2,120.1,44.8z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3158 -0.9488 0.9488 0.3158 -24.224 228.2463)",
    className: "st0",
    cx: 146.1,
    cy: 130.9,
    rx: 13.9,
    ry: 13.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.5,148.8c-1.8-3.2-0.7-7.2,2.5-9c3.2-1.8,7.2-0.7,9,2.5c1.8,3.2,0.7,7.2-2.5,9 C190.3,153.1,186.3,152,184.5,148.8z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8697 -0.4936 0.4936 0.8697 -46.5847 103.0271)",
    className: "st0",
    cx: 171.8,
    cy: 139.7,
    rx: 8.6,
    ry: 8.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9906 -0.1368 0.1368 0.9906 -12.4526 21.3003)",
    className: "st0",
    cx: 148.8,
    cy: 101.3,
    rx: 13.9,
    ry: 13.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.1,100.4c-3-2-3.8-6.1-1.7-9.1c2-3,6.1-3.8,9.1-1.7c3,2,3.8,6.1,1.7,9.1 C198.2,101.6,194.1,102.4,191.1,100.4z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5616 -0.8274 0.8274 0.5616 -4.0841 187.8997)",
    className: "st0",
    cx: 175.3,
    cy: 97.8,
    rx: 8.6,
    ry: 8.6
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7991 -0.6012 0.6012 0.7991 -18.4117 95.9796)",
    className: "st0",
    cx: 134.4,
    cy: 75.5,
    rx: 13.9,
    ry: 13.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.9,54.1c-3.6-0.3-6.3-3.5-6-7.1c0.3-3.6,3.5-6.3,7.1-6c3.6,0.3,6.3,3.5,6,7.1 C177.7,51.8,174.6,54.5,170.9,54.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.2,68.1c-4.7-0.4-8.2-4.6-7.8-9.3c0.4-4.7,4.6-8.2,9.3-7.8c4.7,0.4,8.2,4.6,7.8,9.3 C164.1,65.1,159.9,68.6,155.2,68.1z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.909 -0.4168 0.4168 0.909 -20.7135 38.9354)",
    className: "st0",
    cx: 78.8,
    cy: 66.9,
    rx: 13.9,
    ry: 13.9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.3,26.6c-1.1,3.5-4.8,5.4-8.2,4.3c-3.5-1.1-5.4-4.8-4.3-8.2c1.1-3.5,4.8-5.4,8.2-4.3 C63.5,19.5,65.4,23.2,64.3,26.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.4,45.6c-1.4,4.5-6.2,7.1-10.8,5.6c-4.5-1.4-7-6.2-5.6-10.8c1.4-4.5,6.3-7.1,10.8-5.6 C74.3,36.2,76.9,41,75.4,45.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,74.8c6.6,3.9,8.8,12.4,5,19c-3.9,6.6-12.4,8.8-19,5c-6.6-3.9-8.8-12.4-5-19 C48.8,73.1,57.3,70.9,63.9,74.8z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9529 -0.3032 0.3032 0.9529 -18.3857 8.0756)",
    className: "st0",
    cx: 16.8,
    cy: 63.2,
    rx: 6.6,
    ry: 6.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,71.7c1.4,4.5-1.1,9.4-5.6,10.8c-4.5,1.4-9.4-1.1-10.8-5.6c-1.4-4.5,1.1-9.4,5.6-10.8 C35.5,64.7,40.4,67.2,41.8,71.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M758,38.4c-1.3-1.8-1.9-4-1.9-6.4c0-3,1-5.3,3.1-6.9c2.1-1.6,5.1-2.4,9.1-2.4c3.8,0,6.8,0.8,9,2.3 s3.2,3.9,3.2,7c0,1.1-0.1,2.3-0.4,3.4c-0.3,1.1-0.7,2-1.1,2.7l-2.1-0.9c0.9-1.6,1.3-3.3,1.3-5.1c0-2.2-0.8-3.8-2.4-4.8 c-1.6-1.1-4.1-1.6-7.4-1.6c-6.5,0-9.8,2.1-9.8,6.4c0,1.8,0.6,3.7,1.7,5.6L758,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M756.5,59.3V47H780v12.2h-2.4v-9.4h-7.3v9.1H768v-9.1h-9.1v9.5H756.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M756.5,82.2v-3l18.5-8.4h-18.5V68H780v3l-18.4,8.5H780v2.7H756.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M777.8,105.9v-7.2h-21.3V96h21.3v-7.3h2.2v17.2H777.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M756.5,125.8v-12.3H780v12.2h-2.4v-9.4h-7.3v9.1H768v-9.1h-9.1v9.5H756.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M756.5,150.9v-3.4l10.7-6.9v-3h-10.7v-2.7H780v6.6c0,2.2-0.5,4-1.6,5.3c-1.1,1.3-2.6,1.9-4.5,1.9 c-1.4,0-2.7-0.5-3.8-1.4c-1.1-0.9-1.9-2.2-2.3-3.9L756.5,150.9z M769.6,137.6v3.4c0,1.4,0.4,2.6,1.2,3.5c0.8,0.9,1.8,1.3,3,1.3 c2.6,0,3.9-1.6,3.9-4.8v-3.5H769.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233.7,
    y: 171.5,
    className: "st0",
    width: 545,
    height: 1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.2,188.9h9.8v2h-7.4v6h6.9v1.9h-6.9v8.2h-2.3V188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.2,200.4c0,4.8-3.3,6.9-6.5,6.9c-3.5,0-6.3-2.6-6.3-6.7c0-4.4,2.9-6.9,6.5-6.9 C265.6,193.7,268.2,196.4,268.2,200.4z M257.8,200.6c0,2.9,1.6,5,4,5c2.3,0,4-2.1,4-5.1c0-2.2-1.1-5-3.9-5 C259,195.5,257.8,198.1,257.8,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.1,198.1c0-1.5,0-2.9-0.1-4.1h2.1l0.1,2.6h0.1c0.6-1.8,2-2.9,3.6-2.9c0.3,0,0.5,0,0.7,0.1v2.2 c-0.2-0.1-0.5-0.1-0.8-0.1c-1.7,0-2.9,1.3-3.2,3.1c-0.1,0.3-0.1,0.7-0.1,1.1v7h-2.3V198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.5,189.1c1.1-0.2,2.6-0.4,4.5-0.4c2.3,0,4,0.5,5.1,1.5c1,0.9,1.6,2.2,1.6,3.8c0,1.6-0.5,2.9-1.4,3.9 c-1.2,1.3-3.3,2-5.6,2c-0.7,0-1.4,0-1.9-0.2v7.3h-2.3V189.1z M314.9,197.9c0.5,0.1,1.2,0.2,1.9,0.2c2.8,0,4.6-1.4,4.6-3.9 c0-2.4-1.7-3.6-4.3-3.6c-1,0-1.8,0.1-2.2,0.2V197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.2,203.5c0,1.3,0,2.5,0.1,3.6h-2.1l-0.1-2.1h-0.1c-0.6,1.1-2,2.4-4.3,2.4c-2.1,0-4.5-1.1-4.5-5.7V194h2.4 v7.2c0,2.5,0.8,4.2,2.9,4.2c1.6,0,2.7-1.1,3.1-2.2c0.1-0.4,0.2-0.8,0.2-1.2v-8h2.4V203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359,207.1c0.1-0.9,0.1-2.2,0.1-3.4v-15.8h2.3v8.2h0.1c0.8-1.5,2.3-2.4,4.5-2.4c3.2,0,5.5,2.7,5.5,6.7 c0,4.7-2.9,7-5.9,7c-1.9,0-3.4-0.7-4.4-2.5h-0.1l-0.1,2.2H359z M361.4,201.8c0,0.3,0.1,0.6,0.1,0.9c0.5,1.6,1.8,2.8,3.6,2.8 c2.5,0,4-2,4-5c0-2.6-1.3-4.9-3.9-4.9c-1.6,0-3.1,1.1-3.6,2.9c-0.1,0.3-0.1,0.6-0.1,1V201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.4,187.9h2.4v19.2h-2.4V187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.3,190.3c0,0.8-0.6,1.5-1.5,1.5c-0.8,0-1.4-0.6-1.4-1.5c0-0.8,0.6-1.5,1.5-1.5 C400.7,188.8,401.3,189.5,401.3,190.3z M398.6,207.1V194h2.4v13.1H398.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.2,206.6c-0.6,0.3-2,0.8-3.8,0.8c-3.9,0-6.5-2.7-6.5-6.7c0-4,2.8-6.9,7-6.9c1.4,0,2.6,0.4,3.3,0.7 l-0.5,1.8c-0.6-0.3-1.5-0.6-2.8-0.6c-3,0-4.6,2.2-4.6,4.9c0,3,1.9,4.9,4.5,4.9c1.3,0,2.2-0.4,2.9-0.6L423.2,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.1,197.8c0,6.3-3.8,9.6-8.4,9.6c-4.8,0-8.2-3.7-8.2-9.2c0-5.8,3.6-9.6,8.4-9.6 C461.9,188.6,465.1,192.4,465.1,197.8z M451,198.1c0,3.9,2.1,7.4,5.8,7.4c3.7,0,5.8-3.4,5.8-7.6c0-3.6-1.9-7.4-5.8-7.4 C453,190.5,451,194.1,451,198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477,198.3c0-1.7-0.1-3-0.1-4.3h2.1l0.1,2.2h0.1c1-1.6,2.5-2.5,4.6-2.5c3.2,0,5.5,2.7,5.5,6.6 c0,4.7-2.9,7-5.9,7c-1.7,0-3.2-0.8-4-2.1h-0.1v7.1H477V198.3z M479.4,201.8c0,0.4,0.1,0.7,0.1,1c0.4,1.6,1.9,2.8,3.6,2.8 c2.5,0,4-2.1,4-5c0-2.6-1.4-4.9-3.9-4.9c-1.6,0-3.1,1.2-3.6,2.9c-0.1,0.3-0.2,0.6-0.2,1V201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.9,190.3c0,0.8-0.6,1.5-1.5,1.5c-0.8,0-1.4-0.6-1.4-1.5c0-0.8,0.6-1.5,1.5-1.5 C503.4,188.8,503.9,189.5,503.9,190.3z M501.3,207.1V194h2.4v13.1H501.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M516.5,197.5c0-1.3,0-2.5-0.1-3.5h2.1l0.1,2.2h0.1c0.6-1.2,2.2-2.5,4.3-2.5c1.8,0,4.6,1.1,4.6,5.6v7.8h-2.4 v-7.5c0-2.1-0.8-3.9-3-3.9c-1.6,0-2.8,1.1-3.2,2.4c-0.1,0.3-0.2,0.7-0.2,1.1v7.9h-2.4V197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M543.1,190.3c0,0.8-0.6,1.5-1.5,1.5c-0.8,0-1.4-0.6-1.4-1.5c0-0.8,0.6-1.5,1.5-1.5 C542.5,188.8,543.1,189.5,543.1,190.3z M540.4,207.1V194h2.4v13.1H540.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M567.5,200.4c0,4.8-3.3,6.9-6.5,6.9c-3.5,0-6.3-2.6-6.3-6.7c0-4.4,2.9-6.9,6.5-6.9 C564.9,193.7,567.5,196.4,567.5,200.4z M557.1,200.6c0,2.9,1.6,5,4,5c2.3,0,4-2.1,4-5.1c0-2.2-1.1-5-3.9-5 C558.3,195.5,557.1,198.1,557.1,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.4,197.5c0-1.3,0-2.5-0.1-3.5h2.1l0.1,2.2h0.1c0.6-1.2,2.2-2.5,4.3-2.5c1.8,0,4.6,1.1,4.6,5.6v7.8h-2.4 v-7.5c0-2.1-0.8-3.9-3-3.9c-1.6,0-2.8,1.1-3.2,2.4c-0.1,0.3-0.2,0.7-0.2,1.1v7.9h-2.4V197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M618,189.1c1.2-0.2,2.9-0.4,4.5-0.4c2.5,0,4.1,0.5,5.3,1.5c0.9,0.8,1.4,2.1,1.4,3.5c0,2.4-1.5,4-3.4,4.6v0.1 c1.4,0.5,2.2,1.8,2.7,3.7c0.6,2.5,1,4.3,1.4,5h-2.4c-0.3-0.5-0.7-2.1-1.2-4.3c-0.5-2.5-1.5-3.5-3.6-3.5h-2.2v7.9H618V189.1z  M620.3,197.4h2.4c2.5,0,4.1-1.4,4.1-3.5c0-2.3-1.7-3.4-4.2-3.4c-1.1,0-1.9,0.1-2.3,0.2V197.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.8,201c0.1,3.2,2.1,4.5,4.5,4.5c1.7,0,2.7-0.3,3.6-0.7l0.4,1.7c-0.8,0.4-2.3,0.8-4.3,0.8 c-4,0-6.4-2.6-6.4-6.6c0-3.9,2.3-7,6.1-7c4.3,0,5.4,3.8,5.4,6.2c0,0.5-0.1,0.9-0.1,1.1H642.8z M649.7,199.3c0-1.5-0.6-3.9-3.3-3.9 c-2.4,0-3.5,2.2-3.6,3.9H649.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.6,204.6c0.7,0.5,1.9,0.9,3.1,0.9c1.7,0,2.5-0.9,2.5-1.9c0-1.1-0.7-1.8-2.4-2.4c-2.3-0.8-3.5-2.1-3.5-3.7 c0-2.1,1.7-3.8,4.5-3.8c1.3,0,2.5,0.4,3.2,0.8l-0.6,1.7c-0.5-0.3-1.5-0.8-2.7-0.8c-1.4,0-2.2,0.8-2.2,1.8c0,1.1,0.8,1.6,2.5,2.2 c2.3,0.9,3.4,2,3.4,3.9c0,2.3-1.8,3.9-4.9,3.9c-1.4,0-2.8-0.4-3.7-0.9L663.6,204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M684.8,201c0.1,3.2,2.1,4.5,4.5,4.5c1.7,0,2.7-0.3,3.6-0.7l0.4,1.7c-0.8,0.4-2.3,0.8-4.3,0.8 c-4,0-6.4-2.6-6.4-6.6c0-3.9,2.3-7,6.1-7c4.3,0,5.4,3.8,5.4,6.2c0,0.5-0.1,0.9-0.1,1.1H684.8z M691.8,199.3c0-1.5-0.6-3.9-3.3-3.9 c-2.4,0-3.5,2.2-3.6,3.9H691.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M713.2,207.1l-0.2-1.6h-0.1c-0.7,1-2.1,1.9-4,1.9c-2.6,0-4-1.9-4-3.8c0-3.2,2.8-4.9,7.9-4.9v-0.3 c0-1.1-0.3-3-3-3c-1.2,0-2.5,0.4-3.4,1l-0.5-1.6c1.1-0.7,2.6-1.2,4.3-1.2c4,0,5,2.7,5,5.3v4.9c0,1.1,0.1,2.2,0.2,3.1H713.2z  M712.8,200.4c-2.6-0.1-5.5,0.4-5.5,2.9c0,1.5,1,2.3,2.2,2.3c1.7,0,2.8-1.1,3.2-2.2c0.1-0.2,0.1-0.5,0.1-0.8V200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.9,198.1c0-1.5,0-2.9-0.1-4.1h2.1l0.1,2.6h0.1c0.6-1.8,2-2.9,3.6-2.9c0.3,0,0.5,0,0.7,0.1v2.2 c-0.2-0.1-0.5-0.1-0.8-0.1c-1.7,0-2.9,1.3-3.2,3.1c-0.1,0.3-0.1,0.7-0.1,1.1v7h-2.3V198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M754.6,206.6c-0.6,0.3-2,0.8-3.8,0.8c-3.9,0-6.5-2.7-6.5-6.7c0-4,2.8-6.9,7-6.9c1.4,0,2.6,0.4,3.3,0.7 l-0.5,1.8c-0.6-0.3-1.5-0.6-2.8-0.6c-3,0-4.6,2.2-4.6,4.9c0,3,1.9,4.9,4.5,4.9c1.3,0,2.2-0.4,2.9-0.6L754.6,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M766.3,187.9h2.4v8.2h0.1c0.4-0.7,1-1.3,1.7-1.7c0.7-0.4,1.5-0.7,2.4-0.7c1.8,0,4.6,1.1,4.6,5.6v7.8h-2.4v-7.5 c0-2.1-0.8-3.9-3-3.9c-1.5,0-2.8,1.1-3.2,2.4c-0.1,0.3-0.2,0.7-0.2,1.1v7.9h-2.4V187.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoperFullLight);
export default __webpack_public_path__ + "static/media/roper_full_light.3fe949e0ecfc980cb9054a33f3499c94.svg";
export { ForwardRef as ReactComponent };